module.exports = __webpack_public_path__ + "img/3.9289cac2.png";